import { PricingPageLayout } from "@/components/wpl/pricing/src/pricing-page-layout";
import { GlobalNav } from "@/patterns/global-nav/src";

export const UsageBasedPricingPage = () => {
    return (
        <PricingPageLayout
            nav={<GlobalNav productKey="usage-based-pricing" />}
        />
    );
};
